module.exports = __webpack_public_path__ + "static/Capital-Tranzado-d5f7aec844cc976e31335e2754c34369.svg";